import { translate } from "../../Common/translations";

export type AwardPointsForWinArguments = {
    pointsForWinning: number;
    multiplierForSubmissionWin: number | null;
};

export type RuleName = "awardPointsForWin";

export type RuleDefinition = {
    selectedCategories: number[];
    rule: RuleName;
    arguments: AwardPointsForWinArguments; //Union type for different rules arguments.
    valid: boolean;
    argumentsAsString: string;
};

export function translateRule(ruleName: string): string {
    return translate(`event_ranking.rule.${ruleName}`);
}
